export default __webpack_public_path__ + "static/media/STBAPLockup_V3.c3dfb491.jpg";